/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { FlexRowDiv } from '@mummssoftware/common-ui/style';
import {
  PlanHeaderDiv,
  RightPlanHeaderDiv,
  RightPlanHeaderWrapper,
  LeftPlanHeaderDiv,
  TitleHeaderDiv,
} from '../../../components/layout/WrapperDiv';
import {
  NoteCountCellRenderer,
  EditCellRenderer,
  StatusCell,
  EffDateCell,
} from '../CellRenderer';
import { cppHeader } from '../../Context/constants';

/** Keep date copy + settings gear on one row; top-align; prevent gear from shrinking on phone. */
const PlanHeaderRightRow = styled(FlexRowDiv)`
  @media (max-width: 600px) {
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    row-gap: 4px;
    & > *:last-child {
      flex-shrink: 0;
    }
  }
`;

type PlanHeaderProps = {
  patientCPP: mumms.patientCarePlanProblem;
  index: number;
};

const RightPlanHeader = ({ patientCPP }: PlanHeaderProps) => (
  <PlanHeaderRightRow id="right-plan-header">
    <RightPlanHeaderWrapper>
      <RightPlanHeaderDiv>
        <EffDateCell patientCPP={patientCPP} />
      </RightPlanHeaderDiv>
      <RightPlanHeaderDiv>
        <StatusCell patientCPP={patientCPP} />
      </RightPlanHeaderDiv>
    </RightPlanHeaderWrapper>
    <EditCellRenderer data={{ patientCPP }} />
  </PlanHeaderRightRow>
);

export const PlanHeader = ({ patientCPP, index }: PlanHeaderProps) => (
  <PlanHeaderDiv id={cppHeader} index={index}>
    <LeftPlanHeaderDiv id={cppHeader}>
      <NoteCountCellRenderer data={patientCPP} />
      <TitleHeaderDiv id={cppHeader}>
        {patientCPP.careplanproblemname}
      </TitleHeaderDiv>
    </LeftPlanHeaderDiv>
    <RightPlanHeader patientCPP={patientCPP} index={index} />
  </PlanHeaderDiv>
);
